import { g as n } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as s, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconPinFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], p = ["clip-path"], m = ["id"];
function h(e, i, r, _, g, t) {
  return d(), s("svg", {
    "aria-label": r.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--pin-filled"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Pin Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      a("path", {
        d: "M8 .563H4a1.437 1.437 0 0 0 0 2.875h.063V5.38a.562.562 0 0 1-.312.504l-.003.001-.889.45a1.437 1.437 0 0 0-.796 1.285v.88a.438.438 0 0 0 .437.438h3.063v2.063a.437.437 0 1 0 .875 0V8.938H9.5a.437.437 0 0 0 .438-.437v-.88a1.438 1.438 0 0 0-.796-1.286l-.892-.451a.562.562 0 0 1-.312-.503V3.438H8A1.438 1.438 0 1 0 8 .563Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, p),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, f);
}
const S = /* @__PURE__ */ u(c, [["render", h]]);
export {
  S as default
};
//# sourceMappingURL=pin-filled.js.map
